import React from "react";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import { DOCS, UPDATED } from "@/lib/legalTexts";

const Text = ({ t }) => t.split(/(\[[^\]]+\])/).map((p, i) => (p.startsWith("[")
  ? <mark key={i} className="bg-gold/25 text-aic-navy font-semibold px-1 rounded" data-testid="legal-placeholder">{p}</mark>
  : <React.Fragment key={i}>{p}</React.Fragment>));

export default function Legal({ doc }) {
  const d = DOCS[doc];
  return (
    <div className="bg-white">
      <div className="bg-aic-navy text-white">
        <div className="max-w-3xl mx-auto px-6 py-14">
          <span className="overline text-gold flex items-center gap-2"><FileText className="w-4 h-4"/>Documenti legali</span>
          <h1 className="font-display text-4xl sm:text-5xl font-bold mt-2" data-testid="legal-title">{d.title}</h1>
          <p className="text-sm text-white/70 mt-3">Ultimo aggiornamento: {UPDATED}</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-12" data-testid={`legal-page-${doc}`}>
        <p className="text-slate-700 leading-relaxed">{d.intro}</p>
        <div className="mt-10 space-y-9">
          {d.sections.map(([title, paras], i) => (
            <section key={title} data-testid={`legal-section-${i}`}>
              <h2 className="font-display text-xl font-bold text-aic-navy">{i + 1}. {title}</h2>
              {paras.length > 1
                ? <ul className="mt-3 space-y-2 list-disc pl-5 text-sm text-slate-700 leading-relaxed marker:text-[#C98A3C]">{paras.map((p) => <li key={p}><Text t={p}/></li>)}</ul>
                : <p className="mt-3 text-sm text-slate-700 leading-relaxed"><Text t={paras[0]}/></p>}
            </section>
          ))}
        </div>
        <div className="mt-12 flex flex-wrap gap-3">
          {[["/privacy", "Privacy"], ["/cookie-policy", "Cookie Policy"], ["/termini", "Termini e Condizioni"]].map(([to, l]) => <Link key={to} to={to} className="btn-pill-outline text-sm">{l}</Link>)}
        </div>
      </div>
    </div>
  );
}
